import { useLocale } from "lib/hooks/useLocale";
import { AddOnMetaType } from "lib/types/checkout";
import { classNames, truncateString } from "lib/utils/helpers";
import defaultPackageImage from "assests/images/package.png";
import { currencyFormatter } from "lib/utils/formatters";
import DotsLoader from "components/common/loaders/DotsLoader";
import OverlaySpinner from "components/common/loaders/OverlaySpinner";

export const AddOnCard = ({
  addOnData,
  isApplied,
  handleAction,
  isLoading,
}: {
  addOnData: AddOnMetaType;
  isApplied: boolean;
  handleAction?: (value: boolean) => void;
  isLoading?: boolean;
}) => {
  const { t } = useLocale();

  return (
    <>
      <div
        className={classNames(
          "bg-white flex justify-between items-center gap-2 p-[10px] rounded-xl border border-gray-light",
        )}>
        <div className="flex items-center gap-2">
          <div className="flex h-9 w-9 items-center justify-center rounded-md">
            <img
              src={addOnData?.image ?? defaultPackageImage}
              alt={addOnData?.product_name ?? "add-on-image"}
              className="h-full w-full rounded-md object-cover"
              onError={({ currentTarget }) => {
                currentTarget.onerror = null;
                currentTarget.src = defaultPackageImage;
              }}
            />
          </div>
          <p className="text-sm font-normal text-coal-dark flex space-x-1 items-center">
            {isApplied ? (
              <span>{`${truncateString(addOnData?.product_name, 40)} added`}</span>
            ) : (
              <div className="flex flex-1 flex-col gap-0">
                <div className="flex items-center gap-1">
                  <span className="text-text-xs-semibold text-zinc-700 line-clamp-1">
                    {truncateString(addOnData?.product_name ?? "Box Packaging", 40)}
                  </span>
                </div>
                <span className="text-text-xs-medium text-zinc-500">
                  {addOnData?.price ? currencyFormatter(addOnData.price) : t("automatic_freebies_free_text")}
                </span>
              </div>
            )}
          </p>
        </div>
        {isApplied ? (
          <div
            onClick={() => handleAction?.(false)}
            className="flex justify-center py-3 pr-3 items-start h-full w-[4.5rem]">
            {isLoading ? (
              <DotsLoader color="var(--flo-primary-dark-color)" />
            ) : (
              <span className="text-sm font-semibold text-coal-dark cursor-pointer rounded-lg py-2">
                {t("remove")}
              </span>
            )}
          </div>
        ) : (
          <div onClick={() => handleAction?.(true)} className="flexjustify-start p-3 items-start w-[4.5rem]">
            {isLoading ? (
              <DotsLoader color="var(--flo-primary-dark-color)" />
            ) : (
              <div
                style={{
                  backgroundColor: "color-mix(in srgb, var(--flo-primary-dark-color) 10%, transparent)",
                }}
                className="text-xs font-medium text-primary-dark cursor-pointer rounded-lg px-3 py-2 border border-primary-dark bg-primary-dark/10">
                {t("add")}
              </div>
            )}
          </div>
        )}
      </div>
      {isLoading && <OverlaySpinner />}
    </>
  );
};
